import { NoteLib, type NoteDegree as NoteDegreeType } from '@tunasong/music-lib'
import type { FC, HTMLAttributes } from 'react'

export interface NoteDegreeProps extends HTMLAttributes<HTMLSpanElement> {
  degree: NoteDegreeType
}

export const NoteDegree: FC<NoteDegreeProps> = ({ degree, style, ...restProps }) => (
  <span
    contentEditable={false}
    style={{
      position: 'relative',
      color: 'var(--tuna-palette-action-active)',
      paddingLeft: 1,
      top: -4,
      fontSize: '0.7em',
      ...style,
    }}
    {...restProps}
  >
    {NoteLib.prettifyNote(degree)}
  </span>
)
